import React from "react";
import Select from "react-select";
import { Icon, TextField } from "office-ui-fabric-react";
import { currecncyOptions, paymentTermsOptions } from "./Constants/Constants";

function getDayDifference(startDate: Date, endDate: Date): number {
    const oneDay = 1000 * 60 * 60 * 24;
    return Math.floor((endDate?.getTime() - startDate?.getTime()) / oneDay) + 1;
}
export function getFilteredPaymentTerms(
    startDate: Date,
    endDate: Date,
    selectedTerm: string
) {
    const days = getDayDifference(startDate, endDate);
    if (selectedTerm === "Indefinite") {
        return paymentTermsOptions;
    }

    const allowed: string[] = ["One Time"];

    if (days > 29) allowed.push("Monthly");
    if (days >= 90) allowed.push("Quarterly");
    if (days >= 180) allowed.push("Half Yearly");
    if (days >= 365) allowed.push("Yearly");

    return paymentTermsOptions.filter(opt => allowed.includes(opt.value));
}

export const formatNumber = (value: string | undefined | null, CurrencySeperatorType: string | undefined | null): string => {
    if (!value) return "";
    if (value === ".") return ".";
    if (/^\d+\.$/.test(value)) return value;

    const num = Number(value);
    if (!isNaN(num)) {
        const [intPart, decPart = ""] = value?.split(".");

        if (CurrencySeperatorType === "NoSeperator") {
            return decPart ? intPart + "." + decPart.slice(0, 2) : intPart;
        }

        if (CurrencySeperatorType === "India") {
            let lastThree = intPart.slice(-3);
            let otherDigits = intPart.slice(0, -3);

            if (otherDigits !== "") {
                otherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
            }

            const formattedInt = otherDigits ? otherDigits + "," + lastThree : lastThree;
            return decPart ? formattedInt + "." + decPart.slice(0, 2) : formattedInt;
        }
        const formattedInt = Number(intPart).toLocaleString("en-US");
        return decPart ? formattedInt + "." + decPart.slice(0, 2) : formattedInt;
    }
    return value;
};

export async function convertCurrency(amount, fromCurrency, stngsCurncyText) {
    try {
        const rates = await fetchExchangeRates(fromCurrency);

        if (!rates[stngsCurncyText]) {
            console.error(
                "Exchange rate not available for the specified currencies."
            );
            return null;
        }

        const exchangeRate = rates[stngsCurncyText];
        const convertedAmount = amount * exchangeRate;
        const parseConverted = parseFloat(convertedAmount?.toString()).toFixed(2)
        return parseConverted;
    } catch (error) {
        console.error("Error converting currency:", error);
        throw error;
    }
}


async function fetchExchangeRates(baseCurrency) {
    try {
        const response = await fetch(
            `https://api.exchangerate-api.com/v4/latest/${baseCurrency}`
        );
        const data = await response.json();
        return data.rates;
    } catch (error) {
        throw error;
    }
}


export const ContractCostTextField = (props) => {
    const CurrencySeperatorType = "International"
    const onChange = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string
    ) => {
        if (!newValue) {
            props.setContractCostData((prev) => ({
                ...prev,
                selectedAmount: "",
            }));
            return;
        }
        const rawValue = newValue.replace(/,/g, "");
        const regex = /^\d*\.?\d{0,2}$/;
        if (!regex.test(rawValue)) return;

        props.setContractCostData((prev) => ({
            ...prev,
            selectedAmount: rawValue,
        }));
    };
    const onCurrencyChange = (ev, opt) => {
        props.setContractCostData((prev) => ({
            ...prev,
            selectedCurrencyKey: ev.key,
            selectedCurrency: ev.text,
        }))
    }
    return (
        <div style={{ display: 'flex', alignItems: 'end', width: '100%' }}>
            <TextField
                id={"ContractCost"}
                styles={{ root: { width: "80%" }, field: { textAlign: "right", '::placeholder': { textAlign: 'left' } } }}
                value={formatNumber(props?.ContractCostData?.selectedAmount, CurrencySeperatorType)}
                type="text"
                placeholder="Enter Contract Cost (optional)"
                onChange={onChange}
                title={props?.ContractCostData?.selectedAmount || ""}
                disabled={props?.disabled} />
            <div style={{ minWidth: '80px' }}>
                <Select
                    maxMenuHeight={200}
                    options={currecncyOptions}
                    value={currecncyOptions.find(
                        (opt) => opt.value === props?.ContractCostData?.selectedCurrency
                    )}
                    onChange={onCurrencyChange}
                    isSearchable
                    isDisabled={props?.disabled}
                    styles={{
                        control: (base, state) => ({
                        ...base,
                        border: state.isFocused ? "1px solid #cdcdcd !important" : base?.border,
                        borderColor: '#c8c8c8',
                        backgroundColor: state.isFocused ? 'rgb(243, 242, 241) !important': base?.backgroundColor,
                        minHeight: '32px',
                        height: "32px",
                        borderRadius: '2px'
                        }),
                    }}
                /></div>
        </div>
    );
};
